<template>
  <section class="bg-[#f5f2ec] px-4 py-10 sm:px-5 md:py-28">
    <div class="mx-auto grid max-w-7xl gap-7 md:gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20">
      <div>
        <p class="section-kicker">Our Story</p>
        <h2 class="section-title">
          Design that turns clear thinking into lasting spaces.
        </h2>
        <div class="section-rule"></div>
        <p class="section-copy">
          We combine architecture, interiors, landscape, and lighting from the
          first conversation so every decision supports the way the space will
          be built, used, and experienced.
        </p>

        <div class="mt-6 grid gap-3 sm:grid-cols-2 md:mt-10 md:gap-4 lg:grid-cols-1">
          <div class="border-l border-[#9b8f78] pl-5">
            <p class="text-sm font-semibold uppercase tracking-[0.2em] text-[#7a6f5d]">Integrated</p>
            <p class="mt-2 leading-7 text-[#59615d]">Architecture, structure, interiors, landscape, lighting, and details coordinated early.</p>
          </div>
          <div class="border-l border-[#9b8f78] pl-5">
            <p class="text-sm font-semibold uppercase tracking-[0.2em] text-[#7a6f5d]">Practical</p>
            <p class="mt-2 leading-7 text-[#59615d]">Planning decisions shaped around climate, comfort, circulation, and long-term value.</p>
          </div>
        </div>
      </div>

      <div class="space-y-4 text-base leading-7 text-[#39423e] md:space-y-5 md:text-lg md:leading-8">
        <p>
          The word phosphene comes from the Greek words meaning “light to show.”
          At PHOSPHENE ARCHITECTS, we help transform ideas, dreams, and mental
          images into meaningful built spaces.
        </p>
        <p>
          We are an integrated architecture and design studio specializing in
          Architecture, Interiors, Landscape, and Lighting Design. Our approach
          focuses on practical planning, climate-responsive design,
          sustainability, comfort, and timeless aesthetics.
        </p>
        <p>
          We believe good design is not about making a project expensive — it is
          about making every space work better for the people who use it. Every
          project is carefully designed by considering natural light,
          ventilation, circulation, functionality, context, and long-term value.
        </p>
        <p>
          What makes us different is our integrated design approach. We
          coordinate architecture, structure, interiors, landscape, lighting, and
          technical details together from the beginning, helping clients avoid
          costly mistakes, site conflicts, unnecessary rework, and poor planning
          during construction.
        </p>
        <p>
          Rather than offering generic solutions, we create personalized spaces
          that reflect each client’s lifestyle, needs, and aspirations.
        </p>
        <p>
          Our work ranges across residential, commercial, hospitality,
          industrial, and high-rise projects, with a strong focus on creating
          spaces that are thoughtful, efficient, aesthetically refined, and
          comfortable to live and experience.
        </p>
        <p class="border-l border-[#9b8f78] pl-4 font-serif text-xl leading-8 text-[#1f2826] md:pl-6 md:text-2xl md:leading-9">
          At PHOSPHENE ARCHITECTS, we don’t just design buildings — we design
          spaces that feel complete, practical, and lasting.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
